import { ContentType } from '@insided/shared/utils/contentType'
import Vote, { VoteProps } from './Vote'
import Like, { LikeProps } from './Like'
import Quote, { QuoteProps } from './Quote'

/* eslint-disable import/no-internal-modules */
import OpenEscalationOptions from '../Escalation/OpenEscalationOptions'
import { Author } from '../interfaces'
import { ConfigContext } from '../utils'

export interface OpeningPostContentActionsProps extends VoteProps, LikeProps, QuoteProps {
  author: Author
  content: string | null
  topicId: number
  contentType: ContentType
  trashed: boolean
  isProductboardNoteCreationEnabled: boolean
  isSalesforceCaseEscalationEnabled: boolean
  isZendeskTicketEscalationEnabled: boolean
  isFreshdeskTicketEscalationEnabled: boolean
}

const OpeningPostContentActions = ({ author, content, topicId, contentType, userId, trashed, votedBy, likedBy, votes, likes, isProductboardNoteCreationEnabled, isSalesforceCaseEscalationEnabled, isZendeskTicketEscalationEnabled, isFreshdeskTicketEscalationEnabled, onChangeVote, onChangeLike }: OpeningPostContentActionsProps) => {
  return (
    <ConfigContext.Consumer>
      {({ contentTypeConfig }) => {
        return (
          <footer className='post--options-list'>
            <div className='post--options-list-container'>
              <OpenEscalationOptions
                isProductboardNoteCreationEnabled={isProductboardNoteCreationEnabled}
                isSalesforceCaseEscalationEnabled={isSalesforceCaseEscalationEnabled}
                isZendeskTicketEscalationEnabled={isZendeskTicketEscalationEnabled}
                isFreshdeskTicketEscalationEnabled={isFreshdeskTicketEscalationEnabled}
                trashed={trashed}
                topicId={topicId}
                contentType={contentType}
                isReply={false}
              />
              {contentTypeConfig.vote &&
                <Vote
                  topicId={topicId}
                  contentType={contentType}
                  userId={userId}
                  votedBy={votedBy}
                  votes={votes}
                  onChangeVote={onChangeVote}
                />}
              {contentTypeConfig.like &&
                <Like
                  topicId={topicId}
                  contentType={contentType}
                  userId={userId}
                  likedBy={likedBy}
                  likes={likes}
                  onChangeLike={onChangeLike}
                />}
              <Quote data-qa='quote-topic' content={content} author={author} />
            </div>
          </footer>
        )
      }}
    </ConfigContext.Consumer>
  )
}

export default OpeningPostContentActions
